var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCultureGenerale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "halal",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6579",
    "data-name": "Group 6579",
    transform: "translate(1.141 1.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14923",
    "data-name": "Path 14923",
    d: "M74.843,57.427,84.7,47.572a1.737,1.737,0,0,0,0-2.456l-9.855-9.854a1.737,1.737,0,0,1-.509-1.228V20.1A1.737,1.737,0,0,0,72.6,18.361H58.66a1.737,1.737,0,0,1-1.228-.509L47.576,8A1.737,1.737,0,0,0,45.12,8l-9.856,9.854a1.737,1.737,0,0,1-1.228.509H20.1A1.737,1.737,0,0,0,18.362,20.1V34.034a1.736,1.736,0,0,1-.509,1.228L8,45.116a1.737,1.737,0,0,0,0,2.456l9.856,9.854a1.737,1.737,0,0,1,.509,1.228V72.591A1.737,1.737,0,0,0,20.1,74.327H34.037a1.737,1.737,0,0,1,1.228.509L45.12,84.69a1.737,1.737,0,0,0,2.456,0l9.856-9.854a1.737,1.737,0,0,1,1.228-.509H72.6a1.737,1.737,0,0,0,1.737-1.737V58.654A1.735,1.735,0,0,1,74.843,57.427Z",
    transform: "translate(-7.489 -7.489)",
    fill: "#91deb6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6580",
    "data-name": "Group 6580",
    transform: "translate(38.537 68.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14924",
    "data-name": "Path 14924",
    d: "M255.839,434.821h3.213a1.7,1.7,0,0,0-1.2.5l-9.632,9.632a1.7,1.7,0,0,1-2.4,0l-.4-.405,9.226-9.227a1.694,1.694,0,0,1,1.2-.5Z",
    transform: "translate(-245.413 -434.821)",
    fill: "#6ed5a1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6581",
    "data-name": "Group 6581",
    transform: "translate(38.537 1.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14925",
    "data-name": "Path 14925",
    d: "M257.851,17.62a1.694,1.694,0,0,0,1.2.5H255.84a1.694,1.694,0,0,1-1.2-.5l-9.226-9.226.4-.407a1.7,1.7,0,0,1,2.4,0Z",
    transform: "translate(-245.414 -7.491)",
    fill: "#6ed5a1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6582",
    "data-name": "Group 6582",
    transform: "translate(63.323 12.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14926",
    "data-name": "Path 14926",
    d: "M417.749,105.555l-9.632,9.632a1.7,1.7,0,0,0-.5,1.2V130.01a1.7,1.7,0,0,1-1.7,1.7h-3.213a1.7,1.7,0,0,0,1.7-1.7V116.388a1.7,1.7,0,0,1,.5-1.2l9.632-9.632a1.7,1.7,0,0,0,0-2.4L404.9,93.523a1.7,1.7,0,0,1-.5-1.2V78.7a1.7,1.7,0,0,0-1.7-1.7h3.213a1.7,1.7,0,0,1,1.7,1.7V92.321a1.7,1.7,0,0,0,.5,1.2l9.632,9.632A1.7,1.7,0,0,1,417.749,105.555Z",
    transform: "translate(-402.709 -77.003)",
    fill: "#6ed5a1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6583",
    "data-name": "Group 6583",
    transform: "translate(8.497 8.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14927",
    "data-name": "Path 14927",
    d: "M109.853,96.2l8.527-8.526a.8.8,0,0,0,0-1.126l-8.527-8.526a.8.8,0,0,1-.233-.563V65.4a.8.8,0,0,0-.8-.8H96.764a.8.8,0,0,1-.563-.233l-8.527-8.526a.8.8,0,0,0-1.126,0L78.02,64.369a.8.8,0,0,1-.563.233H65.4a.8.8,0,0,0-.8.8V77.456a.8.8,0,0,1-.233.563l-8.527,8.526a.8.8,0,0,0,0,1.126L64.368,96.2a.8.8,0,0,1,.233.563v12.057a.8.8,0,0,0,.8.8H77.457a.8.8,0,0,1,.563.233l8.527,8.526a.8.8,0,0,0,1.126,0l8.527-8.526a.8.8,0,0,1,.563-.233h12.059a.8.8,0,0,0,.8-.8V96.76A.8.8,0,0,1,109.853,96.2Z",
    transform: "translate(-55.608 -55.609)",
    fill: "#fff3de"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6584",
    "data-name": "Group 6584",
    transform: "translate(38.472 62.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14928",
    "data-name": "Path 14928",
    d: "M253.005,399.029h3.26a.775.775,0,0,0-.547.228l-8.289,8.289a.776.776,0,0,1-1.094,0l-1.082-1.082,7.205-7.207a.775.775,0,0,1,.547-.228Z",
    transform: "translate(-245.253 -399.029)",
    fill: "#ffe5c2"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6585",
    "data-name": "Group 6585",
    transform: "translate(38.472 8.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14929",
    "data-name": "Path 14929",
    d: "M255.719,64.124a.776.776,0,0,0,.547.228h-3.26a.775.775,0,0,1-.547-.228l-7.205-7.205,1.082-1.084a.776.776,0,0,1,1.094,0Z",
    transform: "translate(-245.254 -55.609)",
    fill: "#ffe5c2"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6586",
    "data-name": "Group 6586",
    transform: "translate(58.727 18.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14930",
    "data-name": "Path 14930",
    d: "M385.194,135.222l-8.287,8.289a.775.775,0,0,0-.228.547v11.723a.774.774,0,0,1-.773.773h-3.26a.774.774,0,0,0,.773-.773V144.058a.775.775,0,0,1,.228-.547l7.292-7.292a2.185,2.185,0,0,0,0-3.087l-7.292-7.292a.775.775,0,0,1-.228-.547V113.568a.774.774,0,0,0-.773-.773h3.26a.774.774,0,0,1,.773.773v11.723a.775.775,0,0,0,.228.547l8.287,8.289A.773.773,0,0,1,385.194,135.222Z",
    transform: "translate(-372.645 -112.795)",
    fill: "#ffe5c2"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6587",
    "data-name": "Group 6587",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14931",
    "data-name": "Path 14931",
    d: "M79.182,37.944,69.333,28.1a.559.559,0,0,1-.165-.4V13.771a2.911,2.911,0,0,0-2.908-2.908H52.332a.559.559,0,0,1-.4-.165L42.084.85a2.912,2.912,0,0,0-4.112,0L28.123,10.7a.56.56,0,0,1-.4.165H13.8a2.911,2.911,0,0,0-2.908,2.908V27.7a.56.56,0,0,1-.165.4L.874,37.944a2.921,2.921,0,0,0,0,4.112L10.723,51.9a.56.56,0,0,1,.165.4v4.4a1.172,1.172,0,0,0,2.344,0V52.3a2.888,2.888,0,0,0-.852-2.056L2.532,40.4a.554.554,0,0,1,0-.8l9.849-9.848a2.888,2.888,0,0,0,.852-2.056V13.771a.564.564,0,0,1,.564-.563H27.724a2.889,2.889,0,0,0,2.056-.852l9.849-9.848a.564.564,0,0,1,.8,0l9.849,9.848a2.89,2.89,0,0,0,2.056.852H66.26a.564.564,0,0,1,.564.563V27.7a2.888,2.888,0,0,0,.852,2.056L77.524,39.6a.554.554,0,0,1,0,.8l-9.849,9.848a2.888,2.888,0,0,0-.852,2.056V66.229a.564.564,0,0,1-.564.563H52.331a2.889,2.889,0,0,0-2.056.852l-9.849,9.848a.565.565,0,0,1-.8,0L29.78,67.644a2.889,2.889,0,0,0-2.056-.852H13.8a.562.562,0,0,1-.564-.553l.036-4.116a1.172,1.172,0,0,0-2.344-.021l-.037,4.127A2.911,2.911,0,0,0,13.8,69.137H27.724a.56.56,0,0,1,.4.165l9.849,9.848a2.911,2.911,0,0,0,4.112,0L51.933,69.3a.56.56,0,0,1,.4-.165H66.26a2.911,2.911,0,0,0,2.908-2.908V52.3a.559.559,0,0,1,.165-.4l9.849-9.848a2.921,2.921,0,0,0,0-4.112Z",
    transform: "translate(-0.028 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14932",
    "data-name": "Path 14932",
    d: "M82.159,48.693a1.977,1.977,0,0,0-2.791,0L70.962,57.1H59.073A1.976,1.976,0,0,0,57.1,59.072V70.96l-8.407,8.405a1.976,1.976,0,0,0,0,2.791L57.1,90.561v11.887a1.976,1.976,0,0,0,1.974,1.974H70.962l8.407,8.405a1.977,1.977,0,0,0,2.791,0l8.406-8.405h11.889a1.976,1.976,0,0,0,1.974-1.974V90.561l8.407-8.406a1.976,1.976,0,0,0,0-2.791l-8.407-8.405V59.072a1.976,1.976,0,0,0-1.974-1.974H90.566l-1.945-1.945a1.178,1.178,0,0,0-1.666,1.666l2.058,2.057a1.961,1.961,0,0,0,1.4.578h11.665V71.118a1.961,1.961,0,0,0,.578,1.4L110.9,80.76l-8.248,8.247a1.961,1.961,0,0,0-.578,1.4v11.663H90.408a1.962,1.962,0,0,0-1.4.578l-8.248,8.247-8.248-8.247a1.961,1.961,0,0,0-1.4-.578H59.455V90.4a1.96,1.96,0,0,0-.578-1.4L50.629,80.76l8.248-8.247a1.961,1.961,0,0,0,.578-1.4V59.455H71.12a1.961,1.961,0,0,0,1.4-.578l8.248-8.247L83.1,52.96a1.178,1.178,0,0,0,1.666-1.666Z",
    transform: "translate(-40.764 -40.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14933",
    "data-name": "Path 14933",
    d: "M242.586,182.8a1.146,1.146,0,0,0-2.293,0v11.337a9.641,9.641,0,0,1-.93,3.685,7.591,7.591,0,0,1-6.414,4.268,1.146,1.146,0,0,0,.262,2.278,10.009,10.009,0,0,0,7.184-3.857,4.835,4.835,0,0,0,6.375,3.575l6.509-2.343a1.146,1.146,0,0,0,.365-1.942l-5.84-5.1a1.146,1.146,0,0,0-1.507,1.728l4.371,3.814-4.674,1.683a2.545,2.545,0,0,1-3.408-2.395V182.8Z",
    transform: "translate(-195.368 -153.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14934",
    "data-name": "Path 14934",
    d: "M232.4,194.906l4.18,3.092a1.146,1.146,0,0,0,1.363-1.843l-4.179-3.092a1.146,1.146,0,0,0-1.364,1.843Z",
    transform: "translate(-195.61 -162.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14935",
    "data-name": "Path 14935",
    d: "M136.458,195.972a1.146,1.146,0,0,0-1.146,1.146v1.763a5.5,5.5,0,0,0,11,0V182.8a1.146,1.146,0,0,0-2.293,0v16.077a3.205,3.205,0,0,1-6.41,0v-1.763A1.146,1.146,0,0,0,136.458,195.972Z",
    transform: "translate(-114.088 -153.019)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCultureGenerale);
export default __webpack_public_path__ + "static/media/icon-culture-generale.bc4d302c.svg";
export { ForwardRef as ReactComponent };